const initializers = [];

/**
 * Adds a modal initializer
 *
 * @param {(element: HTMLElement) => void} callback
 */
export function registerModalInitializer (callback)
{
	initializers.push(callback);
}

/**
 * (Re-)Initializes all components in the modal
 *
 * @param {HTMLElement} container
 */
export function initModalComponents (container)
{
	initializers.forEach(init => init(container));
}
